/**
 *
 * ShapedImage
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { typeTest, rotateFile } from 'utils/files.js';
import Square from './Square/index.jsx';

import ImagePreview from './ImagePreview.jsx';
import ActionTrigger from './ActionTrigger.jsx';
import PrimaryProgressBar from './PrimaryProgressBar.js';

// const FullWidth = styled.div`
//   & > div > div {
//     flex: 0 0 100%;   // Fix for IE 11
//     min-height: 100px;
//     ${centerCss}
//   }
// `;

const ImageProgressBar = styled(PrimaryProgressBar)`
  position: absolute;
  bottom: 0;
  left: 0;
  right:0;
`;

function ShapedImage(props) {
  const { className, onChange, forceSquare, item, noRetry, onClick, disabled, overlay, onDelete } = props;
  const { file } = item;
  const canRotate = file && file?.canRotate && typeTest('image', file);

  async function handleRotate() {
    const rotated = await rotateFile(file);
    onChange({ ...item, file: rotated });
  }

  const Shaper = forceSquare ? Square : 'div';

  function handleDelete() {
    if (onDelete) {
      onDelete(item);
    }
  }

  const result = (
    <Shaper key={item.id}>
      <div className={className}>
        <ImagePreview
          file={item}
          fullview={!forceSquare}
          overlay={overlay}
          noRetry={noRetry}
        />
      </div>
      {onChange && (
        <ActionTrigger
          onDelete={onDelete && handleDelete}
          onRotate={canRotate && handleRotate}
        />
      )}
      {item.loading && <ImageProgressBar now={item.progress} label={`${item.progress}%`} />}
    </Shaper>
  );
  return onClick ? <Button variant="link" className="p-0 rounded-0" onClick={onClick} disabled={disabled}>{result}</Button> : result;
}

ShapedImage.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  onClick: PropTypes.func,
  noRetry: PropTypes.bool,
  item: PropTypes.object,
  overlay: PropTypes.string,
  disabled: PropTypes.bool,
  forceSquare: PropTypes.bool,
};

export default ShapedImage;
